import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import commonEn from "./en/commonEn";
import commonAr from "./ar/commonAr";
import userManagementEn from "./en/userManagementEn";
import userManagementAr from "./ar/userManagementAr";
import hrEn from "./en/hrEn";
import hrAr from "./ar/hrAr";
import purchaseEn from "./en/purchaseEn";
import purchaseAr from "./ar/purchaseAr";
import salesEn from "./en/salesEn";
import salesAr from "./ar/salesAr";
import inventoryEn from "./en/inventoryEn";
import inventoryAr from "./ar/inventoryAr";

const resources = {
    en: {
        translation: {
            ...commonEn,
            ...userManagementEn,
            ...hrEn,
            ...purchaseEn,
            ...salesEn,
            ...inventoryEn,
        }
    },
    ar: {
        translation: {
            ...commonAr,
            ...userManagementAr,
            ...hrAr,
            ...purchaseAr,
            ...salesAr,
            ...inventoryAr,
        }
    }
};

// Initialize i18next
i18n.use(initReactI18next).init({
    resources,
    lng: "en", // Default language
    fallbackLng: "en",
    interpolation: { escapeValue: false }
});

export default i18n;